import { useEffect } from 'react'
import Header from './components/Header'
import ContactPresentation from './components/contact/contactPresentation'
import ContactForm from './components/contact/contactForm'
import ContactFindUs from './components/contact/contactFindUs'
import FooterNew from './components/FooterNew'

function Contact() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const path = url.pathname.toLowerCase();

    // Legacy path: /financement -> /contact?type=financement
    if (path === '/financement') {
      window.history.replaceState({}, '', '/contact?type=financement');
      return;
    }

    const raw = (
      url.searchParams.get('type') ||
      url.search.replace('?', '') ||
      url.hash.replace('#', '')
    ).toLowerCase();

    if (raw === 'financement' && url.searchParams.get('type') !== 'financement') {
      window.history.replaceState({}, '', `${url.pathname}?type=financement`);
    }

    // Scroll to the form when arriving via the financement link
    if (raw === 'financement') {
      const scrollToForm = () => {
        const form = document.getElementById('contactForm');
        if (form) {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          // Form not yet rendered (data still loading), retry
          setTimeout(scrollToForm, 100);
        }
      };
      setTimeout(scrollToForm, 300);
    }
  }, []);

  return (
    <>
      <Header/>
      <ContactPresentation/>
      <ContactForm/>
      <ContactFindUs/>
      <FooterNew/>
    </>
  )
}

export default Contact